var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "24 / basic / dashboard"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.82399 15.4407C1.87757 13.9783 0.708496 11.6895 0.708496 9.20768C0.708496 4.90446 4.19694 1.41602 8.50016 1.41602C12.8034 1.41602 16.2918 4.90446 16.2918 9.20768C16.2918 11.6895 15.1228 13.9783 13.1763 15.4407L12.9873 15.5827H4.01303L3.82399 15.4407ZM12.5075 14.166C13.9919 12.9654 14.8752 11.1606 14.8752 9.20768C14.8752 5.68687 12.021 2.83268 8.50016 2.83268C4.97935 2.83268 2.12516 5.68687 2.12516 9.20768C2.12516 11.1606 3.00844 12.9654 4.49279 14.166H12.5075ZM12.268 5.36388L11.1074 4.55148L9.2423 7.21587C9.01126 7.12975 8.76121 7.08268 8.50016 7.08268C7.32656 7.08268 6.37516 8.03408 6.37516 9.20768C6.37516 10.3813 7.32656 11.3327 8.50016 11.3327C9.67377 11.3327 10.6252 10.3813 10.6252 9.20768C10.6252 8.81424 10.5182 8.44576 10.3319 8.12974L12.268 5.36388ZM9.2085 9.20768C9.2085 9.59888 8.89136 9.91602 8.50016 9.91602C8.10896 9.91602 7.79183 9.59888 7.79183 9.20768C7.79183 8.81648 8.10896 8.49935 8.50016 8.49935C8.89136 8.49935 9.2085 8.81648 9.2085 9.20768Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard2);
export default __webpack_public_path__ + "static/media/dashboard2.2dbaf5c3.svg";
export { ForwardRef as ReactComponent };